import React from 'react';

const steps = [
  {
    number: '01',
    title: 'Initial Consultation',
    description: 'Comprehensive virtual assessment of your health history, symptoms, and wellness goals.',
    icon: 'ri-user-heart-line',
    duration: '45-60 minutes'
  },
  {
    number: '02',
    title: 'Diagnostic Testing',
    description: 'At-home lab testing kit delivered to your door for comprehensive biomarker analysis.',
    icon: 'ri-test-tube-line',
    duration: '3-5 business days'
  },
  {
    number: '03',
    title: 'Treatment Planning',
    description: 'Personalized treatment protocol designed based on your unique test results and health profile.',
    icon: 'ri-file-text-line',
    duration: '1-2 business days'
  },
  {
    number: '04',
    title: 'Treatment Delivery',
    description: 'Medications and supplements shipped directly to your home with detailed instructions.',
    icon: 'ri-truck-line',
    duration: '2-3 business days'
  },
  {
    number: '05',
    title: 'Ongoing Monitoring',
    description: 'Regular check-ins, progress tracking, and treatment adjustments as needed.',
    icon: 'ri-line-chart-line',
    duration: 'Continuous'
  }
];

const ProcessSection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Your <span className="text-blue-600">Treatment Journey</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our streamlined process ensures you receive the highest quality care from the comfort of your home, 
            with <strong>personalized attention</strong> every step of the way.
          </p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-gradient-to-r from-blue-200 via-teal-200 to-purple-200"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="text-center">
                  <div className="relative inline-block mb-6">
                    <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-teal-500 rounded-full flex items-center justify-center shadow-lg">
                      <i className={`${step.icon} text-white text-2xl`}></i>
                    </div>
                    <div className="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-md border-2 border-blue-500">
                      <span className="text-blue-600 font-bold text-sm">{step.number}</span>
                    </div>
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                  <p className="text-gray-600 text-sm mb-3 leading-relaxed">{step.description}</p>
                  <div className="inline-flex items-center px-3 py-1 bg-gray-100 rounded-full">
                    <i className="ri-time-line text-gray-500 mr-1 text-xs"></i>
                    <span className="text-gray-600 text-xs font-medium">{step.duration}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 bg-gradient-to-r from-blue-50 to-teal-50 rounded-2xl p-8">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Ready to Start Your Journey?</h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Join thousands of patients who have transformed their health through our personalized 
              <strong> telemedicine approach</strong>. Your wellness journey starts with a simple consultation.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="px-8 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-video-line mr-2"></i>
                Book Free Consultation
              </button>
              <button className="px-8 py-3 border border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-phone-line mr-2"></i>
                Call (555) VITAL-MED
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;